import apiClient from './apiClient'
import { CLAIM_DASHBOARD } from './apiEndpoints'
import { getMessage } from '@/utils/messages'
import { log } from '@/utils/logger'
import type { DashboardRequest, DashboardResponse } from '@/types/dashboard'

type ServiceError = { response?: { data: unknown }; request?: unknown; message?: string }

export async function getDashboard(
  request: DashboardRequest
): Promise<DashboardResponse> {
  log.info('getDashboard start', { userId: request.userId, pageNumber: String(request.pageNumber) })

  const params = new URLSearchParams({
    userId: request.userId,
    pageNumber: String(request.pageNumber),
    pageSize: String(request.pageSize),
    sortBy: request.sortBy,
    sortDirection: request.sortDirection,
  })

  if (request.search) params.set('search', request.search)
  if (request.status) params.set('status', String(request.status))
  if (request.vehicleType) params.set('vehicleType', String(request.vehicleType))

  try {
    const { data } = await apiClient.get<DashboardResponse>(
      `${CLAIM_DASHBOARD}?${params}`
    )
    log.info('getDashboard success', {
      userId: request.userId,
      totalRecords: String(data.pagination?.totalRecords ?? 0),
    })
    return data
  } catch (error: unknown) {
    const err = error as ServiceError
    if (err.response) {
      log.error('getDashboard failed — server error', new Error('API error'), { userId: request.userId })
      throw new Error(getMessage('dashboard.error_server'))
    } else if (err.request) {
      log.error('getDashboard failed — no response', new Error('Network error'), { userId: request.userId })
      throw new Error(getMessage('api.error.no_response'))
    } else {
      log.error('getDashboard failed — unexpected', new Error((err as { message?: string }).message ?? 'Unknown'), { userId: request.userId })
      throw new Error((err as { message?: string }).message || getMessage('api.error.unexpected'))
    }
  }
}
